module.exports = __webpack_public_path__ + "static/media/168.0948792b.webp";